import { i18n } from '@/config/i18n'

function recordNotFound(error) {
  return {
    code: error.code,
    message:
      i18n.t(`errors.server.${error.code}`, {
        model: i18n.t(`models.${error.additionalProperties.model}.name`),
      }) || `${error.code} - Erro desconhecido`,
  }
}

function modelValidation(error) {
  const constraints = error.additionalProperties.errors.map(e => {
    return {
      property: e.property,
      messages:
        e.constraints.map(constraint =>
          i18n.t(`errors.modelValidationConstraints.${constraint}`, {
            property: i18n.t(
              `models.${error.additionalProperties.modelName}.properties.${e.property}`,
            ),
          }),
        ) || `${e.property} - Erro desconhecido`,
    }
  })
  return {
    code: error.code,
    message:
      i18n.t(`errors.server.${error.code}`) ||
      `${error.code} - Erro desconhecido`,
    constraints,
  }
}

const mapTranslators = {
  recordNotFound,
  modelValidation,
}

export default error => {
  const translator = mapTranslators[error.response.data.code]

  if (translator) {
    return translator(error.response.data)
  }
  return {
    code: error.response.data.code,
    message:
      i18n.t(`errors.server.${error.response.data.code}`) ||
      `${error.response.data.code} - Erro desconhecido`,
  }
}
